import { Link } from "@components/Link/Link";
import React from "react";
import tw from "twin.macro";
import { Breadcrumb } from "../Breadcrumb/Breadcrumb";
import { StyledButton } from "../Styled/Button";
import { BackgroundContainer, StyledContainer } from "../Styled/Container";
import { StyledH1 } from "../Styled/Text";
import { ErrorOutputProps, withError } from "./withError";
import { Sections } from "../Sections/Sections";

const Container = tw(StyledContainer)`
  pt-peta pb-giga flex items-center flex-col relative
`;

const Title = tw(StyledH1)`
  mb-mini md:mb-maxi text-center
`;

const Button = tw(StyledButton)`
  w-full max-w-[232px] sm:max-w-[320px]
`;

export const ErrorPage = withError(
  ({ title, buttonText, buttonLink, paths, content }: ErrorOutputProps) => (
    <>
      <BackgroundContainer background="light">
        <Container>
          {paths && <Breadcrumb paths={paths} />}
          <Title>{title}</Title>
          {buttonText && buttonLink ? (
            <Button
              as={buttonLink ? Link : null}
              to={buttonLink}
              height="56"
              textSize="56"
              colour="light"
              border
            >
              {buttonText}
            </Button>
          ) : null}
        </Container>
        <Sections page={{ content }} />
      </BackgroundContainer>
    </>
  ),
);

export default ErrorPage;
